import { render, staticRenderFns } from "./return-card.vue?vue&type=template&id=db9a0b10&scoped=true&"
import script from "./return-card.vue?vue&type=script&lang=ts&"
export * from "./return-card.vue?vue&type=script&lang=ts&"
import style0 from "./return-card.vue?vue&type=style&index=0&id=db9a0b10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9a0b10",
  null
  
)

export default component.exports